import { Pipe, PipeTransform } from '@angular/core';

export const getScoreColor = (scoreString: string | number) => {
  const score = typeof scoreString === 'string' ? Number(scoreString) : scoreString;
  if (isNaN(score) || (score === 0 && scoreString === '')) {
    return 'soft';
  }
  if (score > 80) {
    return 'success';
  } else if (score > 20) {
    return 'warning';
  } else {
    return 'error';
  }
};

@Pipe({
  name: 'scoreColor',
})
export class SupplierContractScoreColorPipe implements PipeTransform {
  transform(scoreString: string | number) {
    return getScoreColor(scoreString);
  }
}
